import { Link } from "react-router-dom";
import { useCart } from "@/lib/cart";
import { BagIcon, SearchIcon } from "./icons";

export function Header() {
  const { totalCount } = useCart();

  return (
    <header className="sticky top-0 z-20 flex items-center justify-between bg-cream/95 px-5 py-5 backdrop-blur">
      <Link to="/" className="flex items-center gap-2">
        <img src="/logo.jpg" alt="" className="h-8 w-8 rounded-full object-cover" />
        <span className="font-display text-xl font-semibold text-ink">Allthingsnew</span>
      </Link>
      <div className="flex items-center gap-4">
        <Link to="/search" aria-label="Search" className="text-ink">
          <SearchIcon />
        </Link>
        <Link to="/cart" aria-label="Bag" className="relative text-ink">
          <BagIcon />
          {totalCount > 0 && (
            <span className="absolute -right-1.5 -top-1.5 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-wine px-1 text-[10px] font-bold text-white">
              {totalCount}
            </span>
          )}
        </Link>
      </div>
    </header>
  );
}
